// Icons
export { default as iconCoinSmall } from './icons/coin-small.png';
export { default as iconImage } from './icons/icon-image.png';
export { default as iconMovie } from './icons/icon-movie.png';
export { default as iconVoice } from './icons/icon-voice.png';

// Menu icons
export { default as iconCard } from './menu/icon-card.png';
export { default as iconCoinBlanc } from './menu/icon-coin-blanc.png';
export { default as iconCoin } from './menu/icon-coin.png';
export { default as iconEdit } from './menu/icon-edit.png';
export { default as iconHistory } from './menu/icon-history.png';
export { default as iconLogin } from './menu/icon-login.png';
export { default as iconLogout } from './menu/icon-logout.png';
export { default as iconMailBox } from './menu/icon-mailbox.png';
export { default as iconPresent } from './menu/icon-present.png';
export { default as iconQuestion } from './menu/icon-question.png';
export { default as iconSerial } from './menu/icon-serial.png';
export { default as iconSetting } from './menu/icon-setting.png';
export { default as iconShipping } from './menu/icon-shipping.png';
export { default as iconUsers } from './menu/icon-users.png';
export { default as iconWChance } from './menu/icon-wchance.png';
export { default as iconArrowRotate } from './menu/icon-arrows-rotate.png';

// WChance images
export { default as wChanceNothing } from './wchance/wchance_nothing.png';
export { default as nothingIcon } from './icons/icon-wchance-nothing.png';
